export default "__VITE_ASSET__DL8s1IxI__"